import { useStores } from "@stores";
import { formatPrice } from "@utils/Format";
import { observer } from "mobx-react-lite";
import { PriceText } from "./styles";

interface MarketItemPriceProps {
  marketAddress: string;
}

// Dynamic price display component - only re-renders when price changes
export const MarketItemPrice = observer(({ marketAddress }: MarketItemPriceProps) => {
  const { marketStore } = useStores();

  const market = marketStore.allMarkets.find((m) => m.addr === marketAddress);
  if (!market) return null;

  const isActiveMarket = marketStore.activeMarket?.addr === market.addr;
  const displayPrice = isActiveMarket ? (marketStore.activeMarket?.mark_price ?? market.mark_price) : market.mark_price;

  return (
    <PriceText data-testid={`favorite-markets:item:${market.addr}:price`} color="accent-contrast">
      ${formatPrice(displayPrice)}
    </PriceText>
  );
});
